import React, { useMemo } from 'react';
import { FormField } from '@src/components/SmartDataTable/types';
import { INVENTORY_STATUS_OPTIONS } from '../constants';

export const useInventoryFormFields = (): ((record?: any) => FormField[]) => {
  return useMemo(
    () => (record?: any) =>
      [
        // Row 1: Medicine (disabled), Current Stock (disabled)
        {
          name: 'medicine_id',
          label: 'Medicine',
          type: 'resourceSelect',
          required: false,
          disabled: true,
          readOnly: true,
          defaultValue: record?.medicine?.id,
          searchSelectProps: {
            resource: 'medicines',
            optionValue: 'id',
            optionRender: (item: any) => (
              <div>
                <span>{item.name}</span>
                <span> ({item.manufacturer})</span>
              </div>
            ),
            allowClear: false,
            disabled: true,
          },
          layout: { span: 12 },
          props: {
            disabled: true,
            readOnly: true,
          },
        },
        {
          name: 'current_stock',
          label: 'Current Stock',
          type: 'number',
          required: false,
          disabled: true,
          readOnly: true,
          placeholder: '0',
          defaultValue: record?.current_stock,
          layout: { span: 12 },
          props: {
            disabled: true,
            readOnly: true,
          },
        },

        // Row 2: Min Stock, Max Stock
        {
          name: 'min_stock',
          label: 'Minimum Stock',
          type: 'number',
          required: true,
          placeholder: '0',
          defaultValue: record?.min_stock,
          layout: { span: 12 },
        },
        {
          name: 'max_stock',
          label: 'Maximum Stock',
          type: 'number',
          required: true,
          placeholder: '100',
          defaultValue: record?.max_stock,
          layout: { span: 12 },
        },

        // Row 3: Supplier (disabled), Purchase Price (disabled)
        {
          name: 'supplier_id',
          label: 'Supplier',
          type: 'resourceSelect',
          required: false,
          disabled: true,
          defaultValue: record?.supplier?.id,
          searchSelectProps: {
            resource: 'suppliers',
            optionValue: 'id',
            optionRender: (item: any) => (
              <div>
                <span>{item.name}</span>
                <span> (+{item.phone})</span>
              </div>
            ),
            allowClear: true,
          },
          layout: { span: 12 },
        },

        {
          name: 'manufacturer_id',
          label: 'MR/Contact Person',
          type: 'resourceSelect',
          required: false,
          disabled: true,
          defaultValue: record?.manufacturer?.id,
          searchSelectProps: {
            resource: 'manufacturers',
            optionValue: 'id',
            optionRender: (item: any) => (
              <div>
                <span>{item.contact_person}</span>
                <span> (+{item.phone})</span>
              </div>
            ),
            allowClear: true,
          },
          layout: { span: 12 },
        },
        {
          name: 'purchase_price',
          label: 'Purchase Price',
          type: 'number',
          required: false,
          disabled: true,
          readOnly: true,
          placeholder: '0.00',
          defaultValue: record?.purchase_price,
          layout: { span: 12 },
          props: {
            disabled: true,
            readOnly: true,
          },
        },

        // Row 4: Purchase Date (disabled), Location
        {
          name: 'purchase_date',
          label: 'Purchase Date',
          type: 'date',
          required: false,
          disabled: true,
          readOnly: true,
          defaultValue: record?.purchase_date,
          layout: { span: 12 },
          props: {
            disabled: true,
            readOnly: true,
          },
        },
        {
          name: 'location',
          label: 'Location',
          type: 'text',
          required: false,
          placeholder: 'Enter storage location...',
          defaultValue: record?.location,
          layout: { span: 12 },
        },

        // Row 5: Status
        {
          name: 'status',
          label: 'Status',
          type: 'select',
          required: true,
          options: INVENTORY_STATUS_OPTIONS,
          defaultValue: record?.status,
          layout: { span: 12 },
        },
      ] as FormField[],
    []
  );
};
